import { createAction, props } from '@ngrx/store';
import type { Data, Params } from '@angular/router';

export const metaDataResetAction = createAction(
  '[Meta] Registered Tags Reset',
  props<{ mergedParams: Params; mergedData: Data; url: string }>()
);

export const overviewDataProcessedAction = createAction('[Meta] OverviewData Processed', props<any>());
export const articleDataProcessedAction = createAction('[Meta] ArticleData Processed', props<any>());
